import { NavigationPath } from 'models/enum';
import { useEffect } from 'react';

export default function useRefresh(
  navigate: any,
  path: string,
  locationState?: unknown
) {
  const resetRoute = NavigationPath.refresh;
  let handler: any;

  const refresh = () => {
    navigate(resetRoute);

    handler = setTimeout(() => {
      navigate(path, { state: locationState });
    }, 10);
  };

  useEffect(() => {
    return () => handler && clearTimeout(handler);
  }, [handler]);

  return refresh;
}
